export enum CUSTOMER_SOURCE {
  CALLCENTER = "CALLCENTER",
  REGISTER = "REGISTER",
  TALABAT = "TALABAT",
  DASHBOARD = "DASHBOARD",
}
